<template>
  <span>
    <label for="">{{ title }}</label>
    <v-select
      class="select"
      v-model="selected_option"
      :label="label"
      id="selectClient"
      :options="paginated_options"
      :filterable="true"
      :placeholder="placeholder"
      :clearable="false"
      :multiple="multiple"
      :disabled="disabled"
      @open="onOpen"
      @close="onClose"
      @search="(query) => (search = query)"
    >
      <template #list-footer>
        <li v-show="hasNextPage" ref="load" class="loader">carregando...</li>
      </template>
      <template v-slot:option="option">
        <slot name="option-custom" v-bind:option="option"></slot>
      </template>
    </v-select>
  </span>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "MySelect",
  props: {
    first_value: {
      value: [Array, Object]
    },
    options: {
      type: [Array, Object],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      dafault: "",
    },
    placeholder: {
      type: String,
      default: "--Selecione--",
    },
    selected_prop: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    change_value: {
      value: [Array, Object]
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      selected_option: null,
      offset: 0,
      limit: 10,
      observer: null,
    };
  },
  watch: {
    selected_option: function (newVal) {
      if (newVal) {
        this.$emit("input", this.selected_prop ? newVal[this.selected_prop] : newVal);
      }
    },
    change_value: function (newVal) {
      this.selected_option = newVal;
    },
  },
  async mounted() {
    !!this.first_value ? this.selected_option = this.first_value : null;
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  computed: {
    paginated_options() {
      return this.options;
      //   return this.options?.slice(0, this.limit);
    },
    hasNextPage() {
      return this.paginated?.length < this.clients?.length;
    },
  },
  methods: {
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.limit += 10;
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
  },
};
</script>

<style lang="scss">
$primary-color: #a8ad19 !default;
.vs__search, .vs__search:focus {
  color: white;
}
.vs__dropdown-menu {
  color: black;
  max-height: 14rem !important;
}
.vs__selected {
  color: white;
  background-color: $primary-color;
  border-radius: 15px;
}
</style>

